import { NavLink  } from 'react-router-dom';

export default function NavUser() {
  	return (
        <div className="nav-align-top">
            <ul className="nav nav-pills flex-column flex-md-row mb-6">
                <li className="nav-item">
                    <NavLink to="/settings-user" className="nav-link">
                        <i className="bx bx-sm bx-user me-1_5"></i>
                        Account
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/security-user" className="nav-link">
                        <i className="bx bx-sm bx-lock-alt me-1_5"></i>
                        Security
                    </NavLink>
                </li>
            </ul>
        </div>
	);
}